import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "custom-search" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-9" }
const _hoisted_6 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_col = _resolveComponent("b-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h5", null, "Ajouter Bon de Livraison stock")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("label", null, "Agence :", -1)),
              _createVNode(_component_v_select, {
                options: _ctx.agencyList,
                modelValue: _ctx.agency,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agency) = $event)),
                label: "name",
                class: "custom-select-height"
              }, {
                option: _withCtx((option) => [
                  _createElementVNode("span", null, _toDisplayString(option.name) + " - " + _toDisplayString(option.nb_colis), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ])
          ]),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              (_ctx.auth.can('ADD_BL_S'))
                ? (_openBlock(), _createBlock(_component_b_button, {
                    key: 0,
                    variant: "primary",
                    class: "mb-1 mb-sm-0 mr-0 mr-sm-1 buttons",
                    onClick: _ctx.addBLS,
                    style: {"margin-top":"1.2rem"}
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode(" Ajouter ", -1)
                    ])),
                    _: 1,
                    __: [2]
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}